import React, { useEffect, useRef, useState } from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { send, videocamOutline } from 'ionicons/icons';

const MI_INPUT_PLACEHOLDER = 'Pergunte à Mi';

export default function GphAgentInput({ onSend, onAttachVideo, disabled = false, blockedNotice = null }) {
  const [value, setValue] = useState('');
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${Math.min(textarea.scrollHeight, 132)}px`;
  }, [value]);

  const submit = () => {
    const text = value.trim();
    if (!text || disabled) return;
    setValue('');
    onSend?.(text);
  };

  const canSubmit = Boolean(value.trim()) && !disabled;

  return (
    <div className="gph-agent-input">
      {blockedNotice && <p className="gph-agent-input__notice">{blockedNotice}</p>}
      <div className="gph-agent-input__row">
        <input
          ref={fileInputRef}
          type="file"
          accept="video/*"
          className="sr-only"
          tabIndex={-1}
          aria-hidden="true"
          onChange={(event) => {
            const file = event.target.files?.[0];
            event.target.value = '';
            if (file) onAttachVideo?.(file);
          }}
        />
        <div className="gph-agent-input__capsule">
          <IonButton
            fill="clear"
            className="gph-agent-input__attach"
            aria-label="Enviar video"
            disabled={disabled}
            onClick={() => fileInputRef.current?.click()}
          >
            <IonIcon icon={videocamOutline} aria-hidden="true" />
          </IonButton>
          <textarea
            ref={textareaRef}
            rows={1}
            className="gph-agent-input__field"
            placeholder={MI_INPUT_PLACEHOLDER}
            aria-label={MI_INPUT_PLACEHOLDER}
            value={value}
            disabled={disabled}
            onChange={(event) => setValue(event.target.value || '')}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                submit();
              }
            }}
          />
          <IonButton
            fill="clear"
            className="gph-agent-input__send"
            aria-label="Enviar mensagem"
            disabled={!canSubmit}
            onClick={submit}
          >
            <IonIcon icon={send} aria-hidden="true" />
          </IonButton>
        </div>
      </div>
    </div>
  );
}
